export const FLAG_GETTING_EXPENSES = 'FLAG_GETTING_EXPENSES';
export const GET_EXPENSES = 'GET_EXPENSES';
export const CLEAR_EXPENSES = 'CLEAR_EXPENSES';
export const GET_EXPENSE = 'GET_EXPENSE';
export const CLEAR_EXPENSE = 'CLEAR_EXPENSE';
export const POST_EXPENSE = 'POST_EXPENSE';
export const PUT_EXPENSE = 'PUT_EXPENSE';
export const FLAG_EXPENSE_ACTIVITY = 'FLAG_EXPENSE_ACTIVITY';
